import { UniversityEntranceQualificationType } from '@/enums'
import amplitudeExperimentService from '@/services/amplitude/amplitude-experiment.service'
import eebPlacement from '@/services/amplitude/eeb-placement.service'
import accountStore from '@/stores/account.store'
import type { WizardPreconditions } from '@/modules/wizard/types/WizardPreconditions'
import type { WizardStepContext } from '@/modules/wizard/types/WizardStepContext'

/**
 * Builds the context flow conditions are evaluated against. Every condition key
 * that is not a backend precondition is derived here, and every experiment a
 * condition depends on is awaited here, so the engine stays flow-agnostic.
 */
class WizardStepContextService {
  /**
   * Resolves once everything the derived keys depend on is settled. The
   * Experiment fetch runs behind the consent flow; without this wait a variant-B
   * user would still see the EEB onboarding step. Bounded by an internal
   * timeout that falls back to control.
   */
  public async whenReady(): Promise<void> {
    await amplitudeExperimentService.whenReady()
  }

  public build(preconditions: WizardPreconditions): WizardStepContext {
    return {
      ...preconditions,
      hasAbroadDiploma:
        preconditions.hasUniversityEntranceQualificationFromAbroad ??
        accountStore.state.account?.universityEntranceQualification ===
          UniversityEntranceQualificationType.UNIVERSITY_ENTRANCE_DIPLOMA_FROM_ABROAD,
      // EEB Placement Experiment (OCPT-860): variant B removes the EEB booking
      // step from onboarding (EEB is shown as a mainscreen task instead).
      isEebInOnboarding: !eebPlacement.isMainscreenVariant(),
    }
  }
}

export default new WizardStepContextService()
